module.exports = __webpack_public_path__ + "img/WI2018.624ef792.jpg";